
/**
 * Class for storing the state of the URM ({@link UnlimitedRegisterMachine})
 */
export class UrmMemento {
    #registers;                 // number[]
    #executedCommandsCount;     // number
    #nextCommandIndex;          // number
    #isFinished;                // boolean

    /**
     *
     * @param registers {number[]}
     * @param executedCommandsCount {number}
     * @param nextCommandIndex {number}
     * @param isFinished {boolean}
     */
    constructor(registers, executedCommandsCount, nextCommandIndex, isFinished) {
        this.#registers = registers;
        this.#executedCommandsCount = executedCommandsCount;
        this.#nextCommandIndex = nextCommandIndex;
        this.#isFinished = isFinished;
    }

    get registers() {
        return this.#registers;
    }

    get executedCommandsCount() {
        return this.#executedCommandsCount;
    }

    get nextCommandIndex(){
        return this.#nextCommandIndex;
    }

    get isFinished() {
        return this.#isFinished;
    }
}